import getAppEnv from '../../../utils/getAppEnv';
import getAppRoot from '../../../utils/getAppRoot';
import { UserInviteCreatedDtoModelType } from '../../../models';
import { pendingInviteReceivedNotification } from '../../../../../notifications/account/pendingInvites';
import { accountSettingsPath } from '../../../../../router/paths';

export default ({ store }: UserInviteCreatedDtoModelType) => {
  const appStore = getAppRoot(store);

  if (appStore.account.myPendingInvitesCount > 0) {
    const navigateToAccountSettings = () => {
      appStore.router.push({ pathname: accountSettingsPath });
    };

    getAppEnv(store).notification(pendingInviteReceivedNotification(appStore.account.myPendingInvitesCount, navigateToAccountSettings));
  }
};

